export class GetOrderStatusService {
    async getByTransactionId(transactionId) {
        const apiUrl = process.env.REACT_APP_API_URL;
        try {
            const url = new URL(`/orders/status/${encodeURIComponent(transactionId)}`, apiUrl);
            const response = await fetch(url.toString(), {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });
            if (!response.ok)
                return null;
            const data = await response.json();
            if (!data || !data.found)
                return null;
            return data;
        }
        catch (_a) {
            return null;
        }
    }
}
